// extracted by mini-css-extract-plugin
module.exports = {"container":"UtilityHighlightsCard_container__X7TxL","logo":"UtilityHighlightsCard_logo__zkDK4","text":"UtilityHighlightsCard_text__QzhX8"};